import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import { APP } from 'src/Configs/App'
import { api } from 'src/Services/api'

import { NameSpace, ErrorCode } from '../types'

export type AutoselectedGenre = {
  id: number
  genreName: string
  relevancy: number
}

export const getAutoselectedSpotifyPlaylistGenres = createAsyncThunk<
  AutoselectedGenre[],
  number
>(
  `${NameSpace.Genres}/getAutoselectedSpotifyPlaylistGenres`,
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.get<AutoselectedGenre[]>(
        `${APP.TIKTOK_SERVER}/curator/playlists/${id}/auto-selected-genres`,
      )
      return data
    } catch (error) {
      const { message, response } = error as AxiosError
      return rejectWithValue({
        message,
        code: response?.status || ErrorCode.InternalServerError,
      })
    }
  },
)
